<header class="navbar navbar-sticky">
  <nav-menu></nav-menu>
  <div class="navbar-right">
    <div class="welcome-banner">
      <span class="welcome-pill">
        <i class="fa fa-user-circle-o" aria-hidden="true"></i>
        <span class="welcome-text">Welcome <strong>{{obj.firstName}} {{obj.lastName}}</strong></span>
      </span>
    </div>
    <toolbar></toolbar>
  </div>
</header>
